import { BaseCamelCasedResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
import { ApplicationStatusId } from "@ploy-lib/types";
export var DocumentType;
(function (DocumentType) {
    DocumentType["Normal"] = "Normal";
    DocumentType["Security"] = "Security";
    DocumentType["Combined"] = "Combined";
    DocumentType["Miscellaneous"] = "Miscellaneous";
})(DocumentType || (DocumentType = {}));
export class ApplicationInfoResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.applicationId = undefined;
        this.vendorName = "";
        this.vendorId = undefined;
        this.loanAmount = undefined;
        this.internalUser = "";
        this.responsibleId = 0;
        this.finalized = false;
        this.backOfficeAccountId = "";
        this.applicationNumber = "";
        this.customerName = "";
        this.customerNumber = "";
        this.customerCompanyNumber = "";
        this.customerId = undefined;
        this.documentStatusId = undefined;
        this.documentStatusNameInternal = "";
        this.documentStatusNameExternal = "";
        this.applicationStatusId = ApplicationStatusId.NotSet;
        this.applicationStatusNameInternal = "";
        this.applicationStatusNameExternal = "";
        this.salesPersonName = "";
        this.salesPersonId = undefined;
        this.productId = undefined;
        this.productName = "";
        this.productNameExternal = "";
        this.productCodeExternal = "";
        this.coSignerName = "";
        this.channel = undefined;
        this.field5 = "";
        this.field7 = "";
        this.field8 = "";
        this.field17 = "";
        this.field18 = "";
        this.followUp = undefined;
        this.carType = "";
        this.carBrandAndModel = "";
        this.applicationLastChanged = undefined;
        this.paidDate = undefined;
        this.inChargeName = "";
        this.invoiceNoRef = "";
    }
    pk() {
        return this.applicationNumber;
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            pollingFrequency: 5000,
            dataExpiryLength: 1000
        };
    }
    static list() {
        return super.list().extend({
            schema: {
                records: [this],
                recordCount: 0,
                pageSize: 1
            }
        });
    }
}
ApplicationInfoResource.urlRoot = apiResourceUrl("application-summary");
export class ApplicationInfoDetailsResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.canCancelApp = false;
        this.responsible = {};
    }
    pk() {
        return this.appNr?.toString();
    }
}
ApplicationInfoDetailsResource.urlRoot = apiResourceUrl("application-summary/{appNr}/details");
export class ApplicationInfoAdditionalExternalResource extends BaseCamelCasedResource {
    pk() {
        return this.accountNumber;
    }
}
ApplicationInfoAdditionalExternalResource.urlRoot = apiResourceUrl("application-summary/additionalexternal");
//# sourceMappingURL=ApplicationInfoResource.js.map